import { render, staticRenderFns } from "./AttachmentGallery.vue?vue&type=template&id=545dd1d6&scoped=true"
import script from "./AttachmentGallery.vue?vue&type=script&lang=js"
export * from "./AttachmentGallery.vue?vue&type=script&lang=js"
import style0 from "./AttachmentGallery.vue?vue&type=style&index=0&id=545dd1d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545dd1d6",
  null
  
)

export default component.exports